//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import options from "@/common/options.json";
export default {
    data() {
        return {
            routerLink: options.routerLink,
            loginState: options.loginState,
            animation: false,
            animationRight: false,
            headActive: false
        };
    },
    components: {
        
    },
    watch: {
        
    },
    methods: {
        onJump(path, type) {
            switch(type) {
                case 1:
                    window.location.href = path;
                    break;
                case 2:
                    window.location.href = path;
                    break;
            }
        },
        userUp() {
            this.animation = false
            this.animationRight = !this.animationRight;
            this.$emit('blur', this.animationRight);
        },
        setScoll() {
            this.animationRight = false
            this.animation = !this.animation;
            this.$emit('blur', this.animation);
        },
        //监听滚动
        getScroll(){
            this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            if (!!document.documentElement.scrollTop &&document.documentElement.scrollTop >= 375){            
                this.headActive = true
            } else {
                this.headActive = false
            }
        }
    },
    mounted() {
        window.addEventListener('scroll', this.getScroll);
    },
    destroyed(){
        window.removeEventListener('scroll', this.getScroll);
    }
};



// WEBPACK FOOTER //
// ./src/components/nav-menu.vue